import { Box, Card, CardContent, makeStyles, Modal } from "@material-ui/core";
import * as React from "react";
import ReactDOM from "react-dom";

import theme from "@/theme";

const useStyles = makeStyles(() => ({
  card: {
    borderRadius: 16,
    maxWidth: "calc(100vw - 48px)",
    maxHeight: "calc(100% - 48px)",
    overflowY: "auto",
    boxShadow: "none",
  },
  cardContent: {
    padding: 0,
    width: 480,
    [theme.breakpoints.down("sm")]: {
      width: 342,
    },
    "&:last-child": {
      paddingBottom: 0,
    },
  },
}));

interface StyledModalProps {
  children: React.ReactNode;
  onClickOutside?: () => void;
  contentWidth?: number | string;
  contentMaxWidth?: number | string;
  role?: "dialog" | "alertdialog";
  ariaLabel?: string;
  labelledBy?: string;
  describedBy?: string;
  /** 入れ子の MUI シートと同じ ModalManager で背景スクロールを管理する。 */
  lockScroll?: boolean;
}

export const StyledModal: React.FC<StyledModalProps> = ({
  children,
  onClickOutside,
  contentWidth,
  contentMaxWidth,
  role,
  ariaLabel,
  labelledBy,
  describedBy,
  lockScroll = false,
}) => {
  const classes = useStyles();

  const overlay = (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      position="fixed"
      top={0}
      left={0}
      width="100%"
      height="100%"
      bgcolor={theme.palette.semantic["surface/overlay"]}
      zIndex={1301}
      onClick={onClickOutside}
    >
      <Card
        className={classes.card}
        onClick={(e) => e.stopPropagation()}
        role={role}
        aria-label={ariaLabel}
        aria-modal={role ? true : undefined}
        aria-labelledby={labelledBy}
        aria-describedby={describedBy}
      >
        <CardContent
          className={classes.cardContent}
          style={{ width: contentWidth, maxWidth: contentMaxWidth ?? "100%" }}
        >
          {children}
        </CardContent>
      </Card>
    </Box>
  );

  if (lockScroll) {
    return (
      <Modal open hideBackdrop disableAutoFocus disableEnforceFocus disableRestoreFocus>
        {overlay}
      </Modal>
    );
  }

  // 角丸や overflow の影響を避けるため Portal で body 直下に描画
  return typeof document !== "undefined" ? ReactDOM.createPortal(overlay, document.body) : overlay;
};
